import { useTranslation } from "react-i18next";
import { Dots } from "../LoadingAnimations/LoadingAnimations";
import { GetVehicleCondition } from "../Tables/Vehicles/GetVehicleCondition";
import { getEta } from "../../Interceptor/csrftoken";
import { useEffect, useState } from "react";
import instance from "../../Interceptor/api_instance";

const LA_TZ = "America/Los_Angeles";

export const MaintenanceTrucks = ({ truckState }) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("yard");
  const [externalTabData, setExternalTabData] = useState([]);
  const [loading, setLoading] = useState(false);
  function compareByPT(aIso, bIso) {
    if (!aIso && !bIso) return 0;
    if (!aIso) return 1;
    if (!bIso) return -1;

    // Same instance regardless of zone; UTC order == PT order
    const a = new Date(aIso).getTime();
    const b = new Date(bIso).getTime();
    return a - b;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await instance.get("safety/get-external-repairs");
        if (response.status === 200) {
          setExternalTabData(response.data.results);
          setLoading(false);
        }
      } catch (err) {
        console.error("Error fetching external repair data:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);
  return (
    <>
      <div className="graphics-card-but-small">
        <h4 className="global-h4 gray">
          {t("graphics-cont.in-maintenance.header")}
        </h4>
        {truckState.error && <p className="error">{truckState.error}</p>}
        <div className="recent-activity">
          {truckState.isFetchingData ? (
            <Dots />
          ) : (
            <>
              <ul className="yard-tabs">
                <li
                  className={selectedTab === "yard" ? "selected" : "tab"}
                  onClick={() => setSelectedTab("yard")}
                >
                  {t("graphics-cont.in-yard")}
                </li>
                <li
                  className={selectedTab === "external" ? "selected" : "tab"}
                  onClick={() => setSelectedTab("external")}
                >
                  {t("forms.type.vehicle.select.trailerCondition.external-repair")}
                </li>
              </ul>
              <div>
                {selectedTab === "yard" && truckState.data
                  .filter(
                    (item) =>
                      item.truck.truckCondition === "under-repair" ||
                      item.truck.truckCondition === "queue" ||
                      item.truck.truckCondition === "waiting-parts" ||
                      item.truck.truckCondition === "waiting-instructions" ||
                      item.truck.truckCondition === "external-repair"
                  )
                  .sort((a, b) =>
                    compareByPT(
                      a.truck.estimated_completion,
                      b.truck.estimated_completion
                    )
                  )
                  .map((item, index) => (
                    <div key={index} className="activity-item">
                      <span className="global-h5 gray">{item.truck.unit}</span>
                      <span>
                        <GetVehicleCondition
                          condition={item.truck.truckCondition}
                        />
                      </span>
                      <span style={{ color: "#FB6060" }}>
                        {getEta(item.truck.estimated_completion)}
                      </span>
                    </div>
                  ))}
                  {selectedTab === "external" && (
                    loading ? <Dots/> : externalTabData.map((item, index) => (
                      <div key={index} className="activity-item">
                        <span className="global-h5 gray">{item.unit}</span>


                      </div>
                    ))
                  )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
